"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Header = exports.Header = function Header(_ref) {
  var title = _ref.title,
      description = _ref.description;

  return _react2.default.createElement("div", { className: "mod-Dialog_Header mod-Dialog_Container" }, title && _react2.default.createElement("p", { className: "hdn-H4 clr-Black util-Ma-b3" }, title), description && _react2.default.createElement("p", { className: "hdn-Pr" }, description));
};